// @flow

import { AccidentService } from '../accident-service';
import { RestApi } from 'app/rgs/api';
import type { AdaptiveTableDataResponse } from 'ko-component-adaptive-table/js/data-provider';

import { CertificateMailingDialogViewModel } from '../../components/certificate-mailing-dialog';
import {
	AccidentMailingListCertificate,
} from '../../view-models/accident-mailing-list-certificate';
import { AccidentMailingList } from './accident-mailing-list-model';

export type ChildMailingModel = {
	ParentMailingListID: string;
	ActionType: string;
	AccidentCertificateIDs: string[],
}

export type MailingListCertificatesParams = {
	take: ?number,
	from?: number,
	onlyCertificatesWithError: boolean,
	onlySuccessCertificates: boolean,
};

export type FetchMailingListsParams = {
	take: number,
	from: number,
	mailingListID?: string,
	accidentContractID?: string,
	startDate?: string,
	endDate?: string,
	statuses?: string,
	types?: string,
}

export class AccidentMailingService extends AccidentService {
	async fetchCertificateMailingLists (
		params: FetchMailingListsParams
	): Promise<AdaptiveTableDataResponse<AccidentMailingList>> {
		const urlParts = [
			...this.API_BASE_URL_PARTS,
			'mailing',
			'lists',
		];

		return this._api.my.get(urlParts, {query: params});
	}

	async createMailingDraft (
		dataModel: CertificateMailingDialogViewModel
	): Promise<CertificateMailingDialogViewModel> {
		const urlParts = [
			...this.API_BASE_URL_PARTS,
			'mailing',
			'lists',
			'draft',
		];
		return this._api.my.post(urlParts, { body: dataModel }).then(({ Data }) => Data);
	}

	async createMailing (
		dataModel: CertificateMailingDialogViewModel | ChildMailingModel
	): Promise<{ MailingListID: string }> {
		const urlParts = [
			...this.API_BASE_URL_PARTS,
			'mailing',
			'create',
		];

		return this._api.my.post(urlParts, { body: dataModel }).then(({ Data }) => Data);
	}

	async fetchMailingListCertificates (
		params: MailingListCertificatesParams,
		mailingListId: string,
	): Promise<AdaptiveTableDataResponse<AccidentMailingListCertificate>> {
		const urlParts = [
			...this.API_BASE_URL_PARTS,
			'mailing',
			'lists',
			mailingListId,
		];

		return this._api.my.get(urlParts, { query: params })
			.then(({ Data }) => ({
				Data: Data.Certificates,
			}));
	}

	getArchiveLink = (mailingListId: string, fileId: string): string => [
		'/api',
		RestApi.API_PREFIX,
		RestApi.API_VERSION,
		...this.API_BASE_URL_PARTS,
		'mailing',
		'lists',
		mailingListId,
		'archive',
		fileId,
	].join('/');

	getDownloadMailingListCertificatesUrl (mailingListId: string, onlySuccess: boolean): string {
		const url = [
			'/api',
			RestApi.API_PREFIX,
			RestApi.API_VERSION,
			...this.API_BASE_URL_PARTS,
			'mailing',
			'lists',
			mailingListId,
			'report',
		].join('/');

		return url + `?onlySuccess=${onlySuccess}`;
	}
}
